module.exports = __webpack_public_path__ + "static/img/banner_01.2e51f89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_01.jpg
// module id = 0xlc
// module chunks = 2